import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ListCalendarComponent} from './list-calendar/list-calendar.component';
import {EditCalendarComponent} from './edit-calendar/edit-calendar.component';
import {CalendarComponent} from './calendar.component';
import {calendarRoutes} from './calendar.routes';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule, MatButtonModule, MatIconModule, MatNativeDateModule, MAT_DATE_LOCALE} from '@angular/material';
import {CalendarCalendarComponent} from './calendar-calendar/calendar-calendar.component';
import {MenuService} from '../menu/menu.service';
import {SharedModule} from '../shared/shared.module';
import {TagsModule} from '../tags/tags.module';
import {DashboardService} from '../dashboard.service';
import {ApiService} from '../api.service';
import {CalendarsService} from './calendars.service';
import {SearchService} from '../search/search.service';
import {SearchResult, SearchResultItem} from '../search/interface.search';

const routing: ModuleWithProviders = RouterModule.forRoot(calendarRoutes);

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatIconModule,
        MatButtonModule,
        SharedModule,
        TagsModule,
        routing
    ],
    declarations: [
        ListCalendarComponent,
        EditCalendarComponent,
        CalendarComponent,
        CalendarCalendarComponent,
    ],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
        CalendarsService
    ],
})
export class CalendarModule {
    constructor(
        protected menuService: MenuService,
        private dashboardService: DashboardService,
        private apiService: ApiService,
        private calendarsService: CalendarsService,
        private searchService: SearchService) {
        this.menuService.addMenuItems(
            [
                {
                    name: 'calendar',
                    path: '/calendar',
                    icon: 'far fa-calendar-alt',
                    children: [
                        {
                            name: 'list',
                            path: '/calendar/list'
                        },
                        {
                            name: 'calendar',
                            path: '/calendar/calendar'
                        },
                        {
                            name: 'new',
                            path: '/calendar/new'
                        }
                    ]
                }]);
        this.dashboardService.fetchItems.subscribe((val) => {
            this.dashboardService.addDashboardItem('calendar', {title: 'Calendar', items: [], footer: '', icon: 'far fa-calendar-alt'});
            this.apiService.getAll('calendar').subscribe(
                (value) => {
                    let calendars: any = value;
                    calendars = calendars.map((calendar) => {
                        calendar.date = new Date(calendar.date);
                        calendar.daysUntil = this.calendarsService.daysUntil(calendar.date);
                        calendar.age = this.calendarsService.today.getFullYear() - calendar.date.getFullYear();
                        if (calendar.date.getMonth() < this.calendarsService.today.getMonth() ||
                            (
                                calendar.date.getMonth() === this.calendarsService.today.getMonth()
                                && calendar.date.getDate() < this.calendarsService.today.getDate()
                            )
                        ) {
                            calendar.age++;
                        }
                        return calendar;
                    }).filter((calendarDate) => calendarDate.daysUntil >= 0);
                    console.log('after mapping: ', calendars);
                    calendars.sort((a, b) => {
                        return b['daysUntil'] < a['daysUntil'] ? 1 : -1;
                    });
                    const limitTo = Math.min(10, calendars.length);
                    calendars.length = limitTo;
                    const dashboardItems: SearchResult = {
                        title: 'Next calendar dates:',
                        items: [],
                        footer: {text: '', buttons: [
                            {link: '/calendar', linkText: 'All date entries', icon: 'far fa-calendar-alt'},
                            {link: '/calendar/new', linkText: 'New date entry', icon: 'fas fa-plus-circle'},
                            ]},
                        icon: 'far fa-calendar-alt'
                    };

                    for (let a = 0; a < calendars.length; a++) {
                        let label = calendars[a].title +
                            ', date: ' + calendars[a].date.toDateString() +
                            ' in ' + calendars[a].daysUntil + ' days';
                        if (calendars[a].repeats) {
                            label += ', repeats: ' + calendars[a].nrrepititions + ' time';
                            if (calendars[a].nrrepititions > 1) {
                                label += 's';
                            }
                        }
                        const resultItem = {
                            label: label,
                            routerLink: ['/calendar/edit/', calendars[a]._id],
                            link: ''
                        };
                        dashboardItems.items.push(resultItem);
                    }
                    if (calendars.length === 0) {
                        dashboardItems.footer.text = 'No dates in the future';
                    }
                    this.dashboardService.addDashboardItem('calendar', dashboardItems);
                }
            );
        });

        this.searchService.getSearchTermSubject().subscribe((val) => {
            this.searchService.addSearchResult('calendar',
                {title: 'Fetching search results for calendar dates ...', items: [], footer: '', icon: 'far fa-calendar-alt'});
            this.apiService.search('calendar', val).subscribe(
                (value: Array<any>) => {
                    const searchResult: SearchResult = {
                        title: 'Calendar dates',
                        items: [],
                        footer: {text: '', buttons: [{link: '/calendar', linkText: 'All date entries'}]},
                        icon: 'far fa-calendar-alt'
                    };
                    for (const item of value) {
                        const date = new Date(item.date);
                        const label = item.title +
                            ', on: ' + date.toDateString();
                        const resultItem = {
                            label: label,
                            routerLink: ['/calendar/edit/', item._id],
                            link: ''
                        };
                        searchResult.items.push(resultItem);
                    }
                    if (value.length === 0) {
                        searchResult.footer.text = 'No results found';
                    }
                    this.searchService.addSearchResult('calendar', searchResult);
                });
        });

    }
}



// WEBPACK FOOTER //
// ./src/app/calendar/calendar.module.ts